/* Pill eyebrow used as the section name above each landing H2.
 *
 * - Brand-tinted gradient pill with brand-coloured hairline border
 * - Leading **amber pulsing dot** (echoes the Clinq logo)
 * - Bumped letter-spacing + weight so the section name reads as a "chapter mark"
 *
 * Tones:
 *   "light" — for light-bg sections (For Business, How We Work)
 *   "dark"  — for the dark For-Funders section
 */
const TONE = {
  light: {
    border:  "border-[#0A8B85]/25",
    bg:      "bg-gradient-to-r from-[#0A8B85]/[0.07] via-white to-[#0A8B85]/[0.07]",
    text:    "text-[#0A8B85]",
    shadow:  "shadow-[0_4px_18px_-8px_rgba(10,139,133,0.35)]",
    dot:     "bg-[#F59E0B]",
    halo:    "rgba(245,158,11,0.55)",
  },
  dark: {
    border:  "border-[#7BD3CE]/35",
    bg:      "bg-gradient-to-r from-[#7BD3CE]/[0.07] via-white/[0.04] to-[#7BD3CE]/[0.07]",
    text:    "text-[#7BD3CE]",
    shadow:  "shadow-[0_4px_18px_-8px_rgba(123,211,206,0.4)]",
    dot:     "bg-[#F59E0B]",
    halo:    "rgba(245,158,11,0.6)",
  },
};

export const SectionEyebrow = ({ children, tone = "light", testid }) => {
  const t = TONE[tone] || TONE.light;
  return (
    <div
      data-testid={testid}
      className={
        "section-eyebrow inline-flex items-center gap-2.5 rounded-full border px-4 py-1.5 " +
        t.border + " " + t.bg + " " + t.shadow
      }
      style={{ "--eyebrow-halo": t.halo }}
    >
      <span className="relative inline-flex">
        <span aria-hidden="true" className={"section-eyebrow-dot block h-1.5 w-1.5 rounded-full " + t.dot} />
      </span>
      <span
        className={"text-[12px] font-extrabold uppercase tracking-[0.22em] " + t.text}
        style={{ fontFamily: "Manrope, sans-serif" }}
      >
        {children}
      </span>
    </div>
  );
};

/* Single global stylesheet for the dot pulse — same easing curve as the logo. */
export const SectionEyebrowStyles = () => (
  <style>{`
    .section-eyebrow { --eyebrow-halo: rgba(245, 158, 11, 0.55); }
    .section-eyebrow-dot {
      box-shadow: 0 0 0 0 var(--eyebrow-halo);
      animation: section-eyebrow-pulse 2.6s ease-out infinite;
    }
    @keyframes section-eyebrow-pulse {
      0%   { box-shadow: 0 0 0 0 var(--eyebrow-halo); }
      70%  { box-shadow: 0 0 0 8px transparent;        }
      100% { box-shadow: 0 0 0 0 transparent;          }
    }
    @media (prefers-reduced-motion: reduce) {
      .section-eyebrow-dot { animation: none; }
    }
  `}</style>
);

export default SectionEyebrow;
